import { useEffect, useState } from "react";
import "../blocks/galleryCard/galleryCard.css";
import { getYoutubeThumbnail } from "../utils/youtube";
import { isDirectVideoFile, getVimeoThumbnail } from "../utils/videoEmbed";

const GalleryCard = ({ item, onDelete, onSelect }) => {
  const { kind, source, url, title } = item;
  const isLinkVideo = kind === "video" && source === "link";
  const isDirectVideo = isLinkVideo && isDirectVideoFile(url);
  const youtubeThumbnail = isLinkVideo ? getYoutubeThumbnail(url) : null;
  const [vimeoThumbnail, setVimeoThumbnail] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (isLinkVideo && !youtubeThumbnail && !isDirectVideo) {
      getVimeoThumbnail(url).then((thumb) => {
        if (!cancelled) setVimeoThumbnail(thumb);
      });
    }
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, isLinkVideo]);

  const linkCoverImage = youtubeThumbnail || vimeoThumbnail;

  return (
    <div className="galleryCard__item">
      <button
        type="button"
        className="galleryCard__thumb-button"
        onClick={onSelect}
        aria-label={title ? `Open ${title}` : "Open media"}
      >
        {kind === "video" ? (
          <div className="galleryCard__video">
            {source === "upload" ? (
              <video
                className="galleryCard__media"
                src={url}
                muted
                preload="metadata"
              />
            ) : linkCoverImage ? (
              <img
                src={linkCoverImage}
                className="galleryCard__media"
                alt={title || "Video link"}
              />
            ) : isDirectVideo ? (
              <video
                className="galleryCard__media"
                src={url}
                muted
                preload="metadata"
              />
            ) : (
              <div className="galleryCard__media galleryCard__video-placeholder" />
            )}
            <span className="galleryCard__play-icon" aria-hidden="true" />
          </div>
        ) : (
          <img
            src={url}
            className="galleryCard__media"
            alt={title || "Album photo"}
          />
        )}
      </button>
      <div className="galleryCard__description">
        {title && <h2 className="galleryCard__title">{title}</h2>}
        <button
          type="button"
          className="galleryCard__delete-button"
          onClick={() => onDelete(item)}
          aria-label="Delete from album"
        >
          Delete
        </button>
      </div>
    </div>
  );
};

export default GalleryCard;
